import { Icon } from '@design/components/icon/Icon';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Search } from '../search/Search';
import styles from './ConditionSearch.module.scss';

export interface ConditionSearchProps {
  label?: string;
  children: ReactNode;
  dataTestId: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ConditionSearch = ({
  label,
  children,
  dataTestId,
  onChange,
}: ConditionSearchProps) => {
  const { t } = useTranslation('scenario');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RadixDropdownMenu.Root data-testid={dataTestId} open={isOpen}>
      <RadixDropdownMenu.Trigger
        className={styles.trigger}
        onClick={() => setIsOpen(true)}
      >
        <span className={styles.triggerLabel}>{label}</span>
        <Icon
          iconName="ChevronLightDown"
          size={12}
          className={styles.triggerArrow}
        />
      </RadixDropdownMenu.Trigger>
      <RadixDropdownMenu.Portal>
        <RadixDropdownMenu.Content
          className={styles.dropdownMenuContent}
          align="start"
          sideOffset={5}
          side="bottom"
          onInteractOutside={() => setIsOpen(false)}
        >
          <Search
            className={styles.styledFilter}
            placeholder={t('scenario:search')}
            onChange={onChange}
          />
          <div
            className={styles.scrollableList}
            role="listbox"
            onClick={() => setIsOpen(false)}
          >
            {children}
          </div>
        </RadixDropdownMenu.Content>
      </RadixDropdownMenu.Portal>
    </RadixDropdownMenu.Root>
  );
};
